import { FilterContentFieldDataTypes } from '../../../../filter/constants';
import { Filter } from '../../../../filter/interface';
import { JOB_OBJECT_STATUS_DATA_MAP } from '../../../constants/job-stage';

const jobsObjectStatusOptions = Object.values(JOB_OBJECT_STATUS_DATA_MAP).map(status => ({
  ...status,
  label: status.displayName
}));

export const JOB_OBJECTS_LIST_FILTER: Filter[] = [
  {
    title: 'Status',
    filterKey: 'so_status',
    filterType: FilterContentFieldDataTypes.LIST,
    filterContentProps: {
      multiple: true,
      options: jobsObjectStatusOptions,
      selectMode: true
    }
  }
];
